import { createInputs } from '../../utils';

export default createInputs([
  { name: 'link', type: 'string', required: true, helperText: 'Lien de redirection' },
  { name: 'size', type: 'number', required: false, helperText: 'Taille du QR Code' },
]);
